import React from 'react'
import Styled from 'styled-components'

const Option = Styled.div`
  position: relative;
  height: 4rem;
  border: 1px solid ${props => props.theme.colors.gray.shade50};
  border-radius: ${props => props.theme.radius};
  transition: 300ms;
  cursor: pointer;
  color: ${props => props.theme.colors.gray.shade400};

  &:hover {
    border-color: ${props => props.theme.colors.gray.shade100};
  }
  
  ${props => props.isActive && `
    border-color: ${props.theme.colors.primary.shade400} !important;
    background-color: ${props.theme.colors.primary.shade400} !important;
    color: ${props.theme.colors.white} !important;
  `}
`

const Icon = Styled.div`
  position: relative;
  height: calc(100% - 0.5rem);
`

const Label = Styled.div`
  position: absolute;
  left: 0;
  bottom: 0.5rem;
  width: 100%;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
`

export default props => (
  <Option isActive={props.isActive} onClick={props.onClick}>
    <Icon>
      {props.children}
    </Icon>
    <Label>{props.label}</Label>
  </Option>
)



// WEBPACK FOOTER //
// ./src/components/ThemeOption/index.js